<template>
  <div class="planning-revenue-bar">
    <StatsBar :show-period-selector="false" :loading="loadingView || loadingMonth">
      <StatsCard
        :label="viewCardLabel"
        :value="viewValue"
        format="currency"
        :loading="loadingView"
        clickable
        @click="$emit('view-click')"
      />
      <StatsCard
        :label="withVatNote($t('planning_page.revenue.this_month'))"
        :value="monthValue"
        format="currency"
        :loading="loadingMonth"
        clickable
        @click="$emit('month-click')"
      />
      <StatsCard
        :label="withVatNote($t('planning_page.revenue.avg_per_day'))"
        :value="avgPerDay"
        format="currency"
        :loading="loadingMonth"
      />
    </StatsBar>
  </div>
</template>

<script>
  import { computed, getCurrentInstance } from 'vue';
  import { StatsBar, StatsCard } from '@/components/partials/stats';

  export default {
    name: 'PlanningRevenueBar',

    components: { StatsBar, StatsCard },

    props: {
      view: { type: String, default: 'week' },
      viewValue: { type: Number, default: 0 },
      monthValue: { type: Number, default: 0 },
      avgPerDay: { type: Number, default: 0 },
      loadingView: { type: Boolean, default: false },
      loadingMonth: { type: Boolean, default: false },
    },

    emits: ['view-click', 'month-click'],

    setup(props) {
      const instance = getCurrentInstance();
      const $t = instance.appContext.config.globalProperties.$t;

      const withVatNote = (label) => `${label} (${$t('planning_page.revenue.excl_vat')})`;

      const viewCardLabel = computed(() =>
        withVatNote(
          props.view === 'day'
            ? $t('planning_page.revenue.this_day')
            : $t('planning_page.revenue.this_week')
        )
      );

      return { viewCardLabel, withVatNote };
    },
  };
</script>

<style scoped lang="scss">
  .planning-revenue-bar {
    flex-shrink: 0;
    padding: 0.75rem 1rem 0;
    background: white;
    border-bottom: 1px solid var(--slate-200);

    :deep(.stats-bar) {
      margin-bottom: 0.75rem;
    }

    :deep(.stats-bar__cards) {
      flex-wrap: nowrap;
    }

    :deep(.stats-card) {
      flex: 1;
      min-width: 0;
    }

    @media (max-width: 768px) {
      :deep(.stats-bar__cards) {
        flex-wrap: wrap;
      }
    }
  }
</style>
